import BaseController from '..';
import { CarrierWeightPricing } from '../../../models/entities/admin/carrierWeightPricing';
import { CarrierPricingResponse } from '../../../models/entities/admin/carrierPricingResponse';
import ICarrierWeightPricing from './ICarrierWeightPricing';

export default class CarrierWeightPricingController extends BaseController implements ICarrierWeightPricing {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    async fetchCarrierWeightPricing(carrierCode: string): Promise<Array<CarrierWeightPricing>> {
        const response = await this.client.get('/companyAdmin/carrier-weight-pricing/carrierCode/' + carrierCode);
        return response;
    }



    async fetchPublicCarrierWeightPricingWithDimensions(
        weight: number, 
        quantity: number, 
        regionId: number, 
        length?: number, 
        width?: number, 
        height?: number
    ): Promise<CarrierPricingResponse> {
        let url = `/public/carrier-weight-pricing/pricing?weight=${weight}&quantity=${quantity}&regionId=${regionId}`;
        
        if (length !== undefined && width !== undefined && height !== undefined) {
            url += `&length=${length}&width=${width}&height=${height}`;
        }
        
        const response = await this.client.get(url);
        return response;
    }

    async updateCarrierWeightPricing(data: CarrierWeightPricing[]): Promise<Array<CarrierWeightPricing>> {
        const response = await this.client.put('/companyAdmin/carrier-weight-pricing/bulk', JSON.stringify(data));
        return response;
    }
}
